import {ModuleRouteManifest} from '../types'

export const committeeRouteManifest: ModuleRouteManifest = {
  code: 'committee',
  privateRoutes: [
    'committee/*',
    'committee-meetings/*',
    'committee-agenda/*',
    'committee-decisions/*',
    'committee-minutes/*',
  ],
}
